import { Component, Input } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SurveyService } from '../../../../services/surveys.service';

@Component({
  selector: 'app-question-options',
  templateUrl: './question-options.component.html',
  styleUrls: ['./question-options.component.scss'],
  standalone: false
})
export class QuestionOptionsComponent {
  @Input() question: any;
  @Input() editable: boolean = false;
  @Input() isResponse: boolean = false;

  constructor(public surveyService: SurveyService) { }

  choiceIdCounter = 1; // Logic for new IDs might need to be smarter or synchronized if important, but local increment usually fine if backend re-assigns or unique enough.
  // Actually, in original component: "this.choiceIdCounter = this.question.choices.length + 1;" in ngOnInit.

  ngOnInit() {
    if (this.question?.choices) {
      this.choiceIdCounter = this.question.choices.length + 1;
      this.question.choices.forEach((choice: any) => {
        if (!choice.customs) {
          choice.customs = {};
        }
      });
    }
  }

  get isCheckboxQuestion(): boolean {
    return this.surveyService.isCheckboxQuestion(this.question.typology);
  }

  get isMultipleChoiceQuestion(): boolean {
    return this.surveyService.isMultipleChoiceQuestion(this.question.typology);
  }

  addChoice() {
    this.question?.choices?.push({
      id: this.choiceIdCounter++,
      title: '',
      customs: {}
    });
  }

  removeChoice(id: number) {
    const index = this.question?.choices.findIndex(choice => choice.id === id);
    if (index !== undefined && index !== -1) {
      this.question.choices.splice(index, 1);
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.question.choices, event.previousIndex, event.currentIndex);
  }
}
